import {WORKSPACE_RESOURCES} from "../../../../constants";
import {SQFTResourceController} from "./SQFTResourceController";

export class Images3dAutoSavedController extends SQFTResourceController {

  constructor(props) {
    super(props);
    this.resourceName = WORKSPACE_RESOURCES.images3dAutoSaved;
  }

  saveBlobAsScreenshot = (blob) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data = reader.result;
      this.addResource(base64data);
    };
    reader.readAsDataURL(blob);
  }
}

